import { Article } from '../models/articles';

export const documentationArticles: Array<Article> = [
  {
    id: 'overview',
    label: 'Overview',
    children: [
      {
        id: 'guide-overview-introduction',
        label: 'Introduction',
        resource: {
          filePath: 'docs-overview/introduction'
        }
      },
      {
        id: 'business-value',
        label: 'Business value',
        resource: {
          filePath: 'docs-overview/business-value'
        }
      },
      {
        id: 'working-with-services',
        label: 'Working with services',
        resource: {
          filePath: 'docs-overview/working-with-services'
        }
      }
    ]
  },

  {
    id: 'getting-started',
    label: 'Getting started',
    resource: {
      filePath: 'docs-overview/getting-started/introduction'
    },
    children: [
      {
        id: 'getting-started-onboarding',
        label: 'Onboarding process',
        resource: {
          filePath: 'docs-overview/getting-started/onboarding-process'
        }
      },
      {
        id: 'getting-started-environments-and-going-live',
        label: 'Environments and going live',
        resource: {
          filePath: 'docs-overview/getting-started/environments-and-going-live'
        }
      },
      {
        id: 'getting-started-operating',
        label: 'Operating your integration with Inpay',
        resource: {
          filePath: 'docs-overview/getting-started/operating'
        }
      }
    ]
  },
  {
    id: 'docs-integration',
    label: 'Integration',
    children: [
      {
        id: 'integration-definitions',
        label: 'Basic concepts',
        content:
          'This section outlines essential information for interacting with our system.',
        children: [
          {
            id: 'integration-definitions-business-units',
            label: 'Business units',
            resource: {
              filePath:
                'docs-overview/integration/definitions/business-units.md'
            }
          },
          {
            id: 'integration-definitions-payload',
            label: 'Payload',
            resource: {
              filePath: 'docs-overview/integration/definitions/payload.md'
            }
          },
          {
            id: 'integration-character-set',
            label: 'Character set',
            resource: {
              filePath: 'docs-overview/integration/character-set.md'
            }
          }
        ]
      },

      {
        id: 'integration-authentication',
        label: 'The authentication and encryption model',
        children: [
          {
            id: 'integration-authentication-introduction',
            label: 'Introduction',
            resource: {
              filePath: 'docs-overview/integration/authentication/introduction'
            }
          },
          {
            id: 'integration-authentication-key-elements',
            label: 'Key elements and standards',
            resource: {
              filePath: 'docs-overview/integration/authentication/key-elements'
            }
          }
        ]
      },
      {
        id: 'integration-needed-setup',
        label: 'Get your API keys',
        resource: {
          filePath: 'docs-overview/integration/needed-setup/get-your-api-keys'
        }
      },
      {
        id: 'integration-webhooks',
        label: 'Webhooks',
        resource: {
          filePath: 'docs-overview/integration/webhooks/description'
        },
        children: [
          {
            id: 'integration-webhooks-needed-setup',
            label: 'Setup',
            resource: {
              filePath: 'docs-overview/integration/webhooks/needed-setup'
            }
          }
        ]
      }
    ]
  },
  {
    id: 'integration-process',
    label: 'Integration Process',
    resource: {
      filePath: 'docs-overview/integration/introduction'
    },
    children: [
      {
        id: 'integration-process-input-data',
        label: 'Input data',
        resource: { filePath: 'docs-overview/integration/input-data' }
      },
      {
        id: 'integration-process-output-data',
        label: 'Output data',
        resource: { filePath: 'docs-overview/integration/output-data' }
      },
      {
        id: 'integration-process-data-security',
        label: 'Data security',
        resource: { filePath: 'docs-overview/integration/data-security' }
      },
      {
        id: 'integration-process-test-verification',
        label: 'Test & verification',
        resource: {
          filePath: 'docs-overview/integration/test-verification'
        }
      },
      {
        id: 'integration-process-prepare',
        label: 'Prepare',
        resource: { filePath: 'docs-overview/integration/prepare' }
      },
      {
        id: 'integration-process-build',
        label: 'Build',
        resource: { filePath: 'docs-overview/integration/build' }
      },
      {
        id: 'integration-process-test',
        label: 'Test',
        resource: { filePath: 'docs-overview/integration/test' }
      },
      {
        id: 'integration-process-setup-prod',
        label: 'Setup for production',
        resource: {
          filePath: 'docs-overview/integration/setup-prod'
        }
      },
      {
        id: 'integration-process-go-live',
        label: 'Go Live',
        resource: {
          filePath: 'docs-overview/integration/go-live'
        }
      },
      {
        id: 'integration-operation-and-maintenance',
        label: 'Operation and maintenance',
        resource: {
          filePath: 'docs-overview/integration/maintenance'
        }
      }
    ]
  },
  {
    id: 'about',
    label: 'About',
    resource: {
      filePath: 'docs-overview/about'
    },
    children: [
      {
        id: 'integration-process-about-api-capabilities',
        label: 'API capabilities',
        resource: {
          filePath: 'docs-overview/about/api-capabilities'
        }
      }
    ]
  }
];
